import {
  FoundationalReportItem,
  GlossaryItem,
  HintItem,
  Live101TrainingItem,
  MethodGuideItem,
  TechGuideItem,
  VideoItem,
  SectorPrimer,
} from '@gslc/models';
import { ActionContext } from 'vuex';
import { GlobalState } from './globalState';

export default {
  refreshVideos(
    { commit }: ActionContext<GlobalState, GlobalState>,
    videos: VideoItem[]
  ): void {
    commit('refreshVideos', videos);
  },
  refreshVideoSettings(
    { commit }: ActionContext<GlobalState, GlobalState>,
    settings: any
  ): void {
    commit('refreshVideoSettings', settings);
  },
  refreshMethodGuides(
    { commit }: ActionContext<GlobalState, GlobalState>,
    methodGuides: MethodGuideItem[]
  ): void {
    commit('refreshMethodGuides', methodGuides);
  },
  refreshLive101Trainings(
    { commit }: ActionContext<GlobalState, GlobalState>,
    live101Trainings: Live101TrainingItem[]
  ): void {
    commit('refreshLive101Trainings', live101Trainings);
  },
  refreshFoundReports(
    { commit }: ActionContext<GlobalState, GlobalState>,
    foundReports: FoundationalReportItem[]
  ): void {
    commit('refreshFoundReports', foundReports);
  },
  refreshTechGuides(
    { commit }: ActionContext<GlobalState, GlobalState>,
    techGuides: TechGuideItem[]
  ): void {
    commit('refreshTechGuides', techGuides);
  },
  refreshHints(
    { commit }: ActionContext<GlobalState, GlobalState>,
    hints: HintItem[]
  ): void {
    commit('refreshHints', hints);
  },
  togglePageLoading(
    { commit }: ActionContext<GlobalState, GlobalState>,
    pageLoading: { loading: boolean; path: '/' }
  ): void {
    commit('togglePageLoading', pageLoading);
  },
  updateWindowWidth(
    { commit }: ActionContext<GlobalState, GlobalState>,
    currentWidth: number
  ): void {
    commit('updateWindowWidth', currentWidth);
  },
  updateSearchQuery(
    { commit }: ActionContext<GlobalState, GlobalState>,
    searchQuery: string
  ): void {
    commit('updateSearchQuery', searchQuery);
  },
  setCurrentVideo(
    { commit }: ActionContext<GlobalState, GlobalState>,
    currentVideo: any
  ): void {
    commit('setCurrentVideo', currentVideo);
  },
  setCurrentFoundationalReport(
    { commit }: ActionContext<GlobalState, GlobalState>,
    currentFoundationalReport: any
  ): void {
    commit('setCurrentFoundationalReport', currentFoundationalReport);
  },
  setGlossaries(
    { commit }: ActionContext<GlobalState, GlobalState>,
    glossaries: GlossaryItem[]
  ): void {
    commit('setGlossaries', glossaries);
  },
  setGlossaryLoading(
    { commit }: ActionContext<GlobalState, GlobalState>,
    glossaryLoading: boolean
  ): void {
    commit('setGlossaryLoading', glossaryLoading);
  },
  setGlossarySearch(
    { commit }: ActionContext<GlobalState, GlobalState>,
    glossarySearch: string
  ): void {
    commit('setGlossarySearch', glossarySearch);
  },
  setGlossarySearchIsLetter(
    { commit }: ActionContext<GlobalState, GlobalState>,
    glossarySearchIsLetter: boolean
  ): void {
    commit('setGlossarySearchIsLetter', glossarySearchIsLetter);
  },
  setSectorPrimers(
    { commit }: ActionContext<GlobalState, GlobalState>,
    sectorPrimers: SectorPrimer[]
  ): void {
    commit('setSectorPrimers', sectorPrimers);
  },
};
